"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.core = exports.Client = exports.appApiSchema = void 0;
const core_1 = require("@zodios/core");
const getActivityById_1 = require("./activity/getActivityById");
const getActivityGoals_1 = require("./activity/getActivityGoals");
const getCurrentActivity_1 = require("./activity/getCurrentActivity");
const listActivities_1 = require("./activity/listActivities");
const listActivitiesModulesByUnit_1 = require("./activity/listActivitiesModulesByUnit");
const listActivityUnits_1 = require("./activity/listActivityUnits");
const getAssessmentForFeedback_1 = require("./assessment/getAssessmentForFeedback");
const getAssessmentReviews_1 = require("./assessmentReview/getAssessmentReviews");
const getAssessmentReviewStats_1 = require("./assessmentReview/getAssessmentReviewStats");
const updateAssessmentReview_1 = require("./assessmentReview/updateAssessmentReview");
const validateAssessmentReview_1 = require("./assessmentReview/validateAssessmentReview");
const uploadAudio_1 = require("./audio/uploadAudio");
const logout_1 = require("./auth/logout");
const sendOTP_1 = require("./auth/sendOTP");
const sendOTPSMS_1 = require("./auth/sendOTPSMS");
const validateOTP_1 = require("./auth/validateOTP");
const getCertificateById_1 = require("./certificate/getCertificateById");
const getCertificateByPublicId_1 = require("./certificate/getCertificateByPublicId");
const listCertificates_1 = require("./certificate/listCertificates");
const redirectToCertificate_1 = require("./certificate/redirectToCertificate");
const getId_1 = require("./consolidatedAssessments/getId");
const getInteractionsAssessments_1 = require("./consolidatedAssessments/getInteractionsAssessments");
const create_1 = require("./conversation/create");
const getResult_1 = require("./conversation/getResult");
const list_1 = require("./conversation/list");
const core = __importStar(require("./core"));
exports.core = core;
const download_1 = require("./file/download");
const createIAPPurchase_1 = require("./iap/createIAPPurchase");
const invite_1 = require("./lead/invite");
const deleteMe_1 = require("./me/deleteMe");
const getMe_1 = require("./me/getMe");
const getStreak_1 = require("./me/getStreak");
const updateMe_1 = require("./me/updateMe");
const getId_2 = require("./messages/getId");
const translate_1 = require("./messages/translate");
const getOnboardingDefaults_1 = require("./onboarding/getOnboardingDefaults");
const getPlacementTestDefaults_1 = require("./placementTest/getPlacementTestDefaults");
const getPlacementTestResult_1 = require("./placementTest/getPlacementTestResult");
const changeActivityStatus_1 = require("./private/changeActivityStatus");
const createActivity_1 = require("./private/createActivity");
const createActivityModule_1 = require("./private/createActivityModule");
const createActivityUnit_1 = require("./private/createActivityUnit");
const deleteActivity_1 = require("./private/deleteActivity");
const deleteActivityModule_1 = require("./private/deleteActivityModule");
const deleteUserActivityByUser_1 = require("./private/deleteUserActivityByUser");
const generateVideosForActivity_1 = require("./private/generateVideosForActivity");
const getActivityById_2 = require("./private/getActivityById");
const listActivitiesSpreadsheet_1 = require("./private/listActivitiesSpreadsheet");
const listModulesSpreadsheet_1 = require("./private/listModulesSpreadsheet");
const listUnitsSpreadsheet_1 = require("./private/listUnitsSpreadsheet");
const listVoicesSpreadsheet_1 = require("./private/listVoicesSpreadsheet");
const loadActivitiesSpreadsheet_1 = require("./private/loadActivitiesSpreadsheet");
const refreshCertificate_1 = require("./private/refreshCertificate");
const reorderActivities_1 = require("./private/reorderActivities");
const takeScreenshot_1 = require("./private/takeScreenshot");
const updateActivity_1 = require("./private/updateActivity");
const updateActivityModule_1 = require("./private/updateActivityModule");
const upload_1 = require("./private/upload");
const listUnconsumed_1 = require("./purchase/listUnconsumed");
const getRanking_1 = require("./ranking/getRanking");
const listReferrals_1 = require("./referrals/listReferrals");
const update_1 = require("./settings/update");
const activity_1 = require("./stats/activity");
const get_1 = require("./stats/get");
const words_1 = require("./stats/words");
const getSummary_1 = require("./summary/getSummary");
const text_1 = require("./translate/text");
const word_1 = require("./translate/word");
const getBeTeacherVoice_1 = require("./voice/getBeTeacherVoice");
const getSample_1 = require("./voice/getSample");
const list_2 = require("./voice/list");
const getWrappedStats_1 = require("./wrapped/getWrappedStats");
exports.appApiSchema = (0, core_1.makeApi)([
    // file
    download_1.downloadFile,
    // placementTest
    getPlacementTestResult_1.getPlacementTestResult,
    getPlacementTestDefaults_1.getPlacementTestDefaults,
    // assessments
    getId_1.getConsolidatedAssessment,
    getInteractionsAssessments_1.getInteractionsAssessments,
    getAssessmentReviews_1.getAssessmentReview,
    updateAssessmentReview_1.updateAssessmentReview,
    getAssessmentReviewStats_1.getAssessmentReviewStats,
    validateAssessmentReview_1.validateAssessmentReview,
    getAssessmentForFeedback_1.getAssessmentForFeedback,
    // conversations routes
    list_1.listConversations,
    create_1.createConversation,
    getResult_1.getConversationResult,
    // iap
    createIAPPurchase_1.createIAPPurchase,
    // me routes
    getMe_1.getMe,
    getStreak_1.getMeStreak,
    updateMe_1.updateMe,
    deleteMe_1.deleteMe,
    // messages routes
    getId_2.getMessageId,
    translate_1.getMessageTranslation,
    // private
    listActivitiesSpreadsheet_1.listActivitiesSpreadsheet,
    listModulesSpreadsheet_1.listModulesSpreadsheet,
    listUnitsSpreadsheet_1.listUnitsSpreadsheet,
    listVoicesSpreadsheet_1.listVoicesSpreadsheet,
    loadActivitiesSpreadsheet_1.loadActivitiesSpreadsheet,
    createActivity_1.createActivity,
    updateActivityModule_1.updateActivityModule,
    updateActivity_1.updateActivity,
    changeActivityStatus_1.changeActivityStatus,
    upload_1.upload,
    reorderActivities_1.reorderActivities,
    getActivityById_2.getPrivateActivityById,
    deleteUserActivityByUser_1.deleteUserActivityByUser,
    deleteActivity_1.deleteActivity,
    generateVideosForActivity_1.generateVideosForActivity,
    createActivityModule_1.createActivityModule,
    createActivityUnit_1.createActivityUnit,
    deleteActivityModule_1.deleteActivityModule,
    takeScreenshot_1.takeScreenshot,
    refreshCertificate_1.refreshCertificate,
    // purchases
    listUnconsumed_1.purchaseListUnconsumed,
    // referrals
    listReferrals_1.listReferrals,
    // stats
    get_1.getStats,
    words_1.getWordsLearnedByMonths,
    activity_1.getActivityPracticeByWeek,
    // settings
    update_1.updateSettings,
    // translate
    text_1.getTextTranslation,
    word_1.getWordTranslation,
    // voices
    list_2.listVoices,
    getSample_1.getVoiceSample,
    getBeTeacherVoice_1.getBeTeacherVoice,
    // activity
    getCurrentActivity_1.getCurrentActivitySchema,
    listActivities_1.listActivitiesSchema,
    listActivitiesModulesByUnit_1.listActivitiesModulesByUnitSchema,
    getActivityById_1.getActivityByIdSchema,
    getActivityGoals_1.getActivityGoalsSchema,
    listActivityUnits_1.listActivityUnitsSchema,
    // ranking
    getRanking_1.getRankingSchema,
    // site
    invite_1.inviteLeadProxy,
    // auth
    logout_1.logout,
    sendOTP_1.sendOTP,
    sendOTPSMS_1.sendOTPSMS,
    validateOTP_1.validateOTP,
    // onboarding
    getOnboardingDefaults_1.getOnboardingDefaults,
    //wrapped
    getWrappedStats_1.getWrappedStats,
    // audio
    uploadAudio_1.uploadAudio,
    // certificate
    getCertificateById_1.getCertificateById,
    getCertificateByPublicId_1.getCertificateByPublicId,
    listCertificates_1.listCertificates,
    redirectToCertificate_1.redirectToCertificate,
    // summary
    getSummary_1.getSummary,
]);
// todo:zodios
class Client extends core_1.Zodios {
    constructor(baseUrl, options = { validate: "request" }) {
        super(baseUrl, exports.appApiSchema, options);
    }
}
exports.Client = Client;
__exportStar(require("./core/schemas"), exports);
__exportStar(require("./core/types"), exports);
__exportStar(require("./core/utils"), exports);
__exportStar(require("./realtimeProxy/index"), exports);
__exportStar(require("./socket/index"), exports);
//# sourceMappingURL=index.js.map